/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_qr_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Download the PNG and print it at any size. Use a higher error-correction level for print so scuffs don't stop it scanning.`)
};

const es_qr_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Descarga el PNG e imprímelo a cualquier tamaño. Usa un nivel de corrección de errores más alto para impresión, así los roces no impiden que se escanee.`)
};

const de_qr_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Lade das PNG herunter und drucke es in beliebiger Größe. Verwende für den Druck eine höhere Fehlerkorrekturstufe, damit Abnutzung das Scannen nicht verhindert.`)
};

const nl_qr_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Download de PNG en print hem op elke gewenste grootte. Gebruik voor print een hoger foutcorrectieniveau zodat krassen het scannen niet verstoren.`)
};

const fr_qr_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Téléchargez le PNG et imprimez-le à n'importe quelle taille. Utilisez un niveau de correction d'erreur plus élevé pour l'impression afin que les rayures n'empêchent pas le scan.`)
};

const it_qr_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Scarica il PNG e stampalo a qualsiasi dimensione. Usa un livello di correzione errori più alto per la stampa così graffi e segni non ne impediscono la lettura.`)
};

const pt_br2_qr_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Baixe o PNG e imprima em qualquer tamanho. Use um nível de correção de erro mais alto para impressão, assim marcas de uso não impedem a leitura.`)
};

const pt_qr_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Descarregue o PNG e imprima-o em qualquer tamanho. Use um nível de correção de erros mais alto para impressão, para que amolgadelas não impeçam a leitura.`)
};

const ja_qr_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。PNGをダウンロードして任意のサイズで印刷できます。印刷用には誤り訂正レベルを高めに設定すると、擦れによる読み取り不良を防げます。`)
};

const zh_qr_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以。下载 PNG 文件后可按任意尺寸打印。打印时建议使用较高的纠错级别，以防磨损影响扫描。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const qr_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.qr_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("qr_faq_a4", locale)
	if (locale === "en") return en_qr_faq_a4(inputs)
	if (locale === "es") return es_qr_faq_a4(inputs)
	if (locale === "de") return de_qr_faq_a4(inputs)
	if (locale === "nl") return nl_qr_faq_a4(inputs)
	if (locale === "fr") return fr_qr_faq_a4(inputs)
	if (locale === "it") return it_qr_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_qr_faq_a4(inputs)
	if (locale === "pt") return pt_qr_faq_a4(inputs)
	if (locale === "ja") return ja_qr_faq_a4(inputs)
	return zh_qr_faq_a4(inputs)
};